import React, { Component } from 'react';
import { AuthContext } from "../../../components/Auth/AuthDataProvider.jsx";
import BreadCrumb from "../../../components/Navs/Breadcrumb"
import { 
  Box,
  Grid,
  CircularProgress
} from '@material-ui/core';
import apiUtil from "../../../api/apiUtil.jsx";
import api from "../../../api/api.jsx";
import ldsApi from "../../../api/ldsApi.jsx";
import { Container, Row, Col, Button, Card, Table } from 'react-bootstrap';
import moment from 'moment';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import evfyLogo from '../../../assets/img/evfy-logo2.png';
import discount0 from '../../../assets/img/discount/discount-1.png';
import discount1 from '../../../assets/img/discount/discount-2.png';
import discount2 from '../../../assets/img/discount/discount-3.png';
import discount3 from '../../../assets/img/discount/discount-4.png';
import stickCircle from '../../../assets/img/circle-checked.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpFromBracket, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { data } from 'jquery';

class Invoice extends Component {
  static contextType = AuthContext;

  constructor(props){
    super(props);

    this.state = {
      jobTabTable: 0,

      dateRangePickerIsOpen: false,
      rangeDate: {
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
      },
      isLoading: false,
      isLoadingStatus: false,
      limit: apiUtil.getDefaultPageSize(),
      data: [],
      status: [],
      status_total: 0,
      fail_total: 0,
      total: 0,
      page: 1,
      total_delivery: 0,
      discount_list: [],
      runIndex : null,

    }
  }
  componentDidMount() {
    this.loadStatusApi();
    this.callReadApi();
  }

  callReadApi = (search = '' ) => {

    let accessToken = localStorage.getItem("access_token")
    this.setState({
      isInvoiceLoading:true
    })
    let param = {
      sort: "latest",
      page: 1,
      take: 3,
      customer: true,
      light_data: true,
      };

      ldsApi.read("client_driver_billings", param, accessToken)
      .then( (results) => {
          apiUtil.parseResult(results, (data) => {
          let result = data.result.length > 0 ? data.result : []
          this.setState({
            data: result,
            isInvoiceLoading: false
          })
          }, (error, type) => {
            apiUtil.toast(error,  'warning', 'error');
            this.setState({
              isInvoiceLoading: false
            })

          });
      });
  }

  callDiscountList = (search = '' ) => {

    let accessToken = localStorage.getItem("access_token")
    this.setState({
      isLoading:true
    })
    let param = {
        // sort: "latest"
      };

      ldsApi.read("order_discounts", param, accessToken)
      .then( (results) => {
          apiUtil.parseResult(results, (data) => {
          let result = data.result.length > 0 ? data.result : []
          result = result.sort((a,b) => a.eligible_order_count - b.eligible_order_count)

          result.length > 0 && result.slice(0, 4).map((discount,index) =>(
            ( this.state.status_total + this.state.fail_total) >= Number(discount.eligible_order_count) ?
            this.setState({
              runIndex: discount.id
            }) : ''
          ))

          result = result.sort((a,b) => a.discount_value - b.discount_value )
          this.setState({
            discount_list: result,
            isLoading: false
          })
          }, (error, type) => {
            this.setState({
              isLoading: false
            })

          });
      });
  }

    /* API */
    callStatusApi = (callback = null) => {
      const { accessToken } = this.context;
  
      this.setState({
        isLoadingStatus: true
      }, () => {
        let startDate = moment(this.state.rangeDate && this.state.rangeDate.startDate).format(apiUtil.getDefaultDateFormat());
        let endDate = moment(this.state.rangeDate && this.state.rangeDate.endDate).format(apiUtil.getDefaultDateFormat());
  
        let param = {
          start_date: startDate,
          end_date: endDate,
          is_invoice_stats: true,
          is_standard:true,
        };
  
        ldsApi.read('orders/job/stats', param, accessToken)
          .then((result) => {
            apiUtil.parseResult(result, (data) => {
              if(data && data.result){
                let total = data.total_delivery;
                let result = Object.keys(data.result).map((k) => data.result[k]);
                
                if(result && result.length > 0){
                  this.setState({
                    isLoadingStatus: false,
                  }, () => {
                    if(callback){
                      callback(result, total);
                    }
                  });
                } else {
                  this.setState({
                    isLoadingStatus: false,
                  }, () => {
                    if(callback){
                      callback(null, 0);
                    }
                  });
                }
              } else {
                this.setState({
                  isLoadingStatus: false,
                }, () => {
                  if(callback){
                    callback(null, 0);
                  }
                });
              }
            }, (error, type) => {
              this.setState({
                isLoadingStatus: false,
              }, () => {
                if(callback){
                  callback(null, 0);
                }
              });
            });
        });
      });
    }

    loadStatusApi = (callback = null) => {
      this.setState({
        isLoadingStatus : true,
      })
      this.callStatusApi((data, total) => {
        if(data && data.length > 0){
          let complete_total = 0;
          let fail_total = 0;
            data.map((item, i) => {
              if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "completed") {
                complete_total = item.total_job;
              }
              if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "failed") {
                fail_total = item.total_job  
              }
            });
          this.setState({
            status_total: complete_total,
            fail_total: fail_total,
            isLoadingStatus: false,
          }, () => {
            
            this.callDiscountList();
            if(callback) {
              callback();
            }
          });
        } else {
          this.setState({
            isLoadingStatus: false,
          })
          if(callback) {
            callback();
          }
        }
      });
    }

  /* EXPORT */
  callExportInvoicePDF () {

    let pdf = new jsPDF("p", "mm", "a4");

    let index = 0;
    // let data = row?[row]:this.state.data;  
    
      if(index!= 0 ){  pdf.addPage(); }
        pdf.addImage(evfyLogo, 'PNG',10,8, 60, 24);
        pdf.setFont("verdana","bold","800");
        pdf.setFontSize(12);
        pdf.text(110,12, 'Evfy Pte Ltd');  

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(110,17, "84 Genting Lane");
        pdf.text(110,22, "#02-02");
        pdf.text(110,27, "Singapore 349584");
        pdf.text(110,32, "ACRA No.: 202121256D");
        pdf.text(110,37, "Email: hello@evfy.sg");
        pdf.text(110,42, "Phone: +65 8932 3141");

        pdf.setFontSize(10);
        pdf.setFont("verdana","bold","800");
        pdf.text(10,48, 'Company Name'); 
        pdf.text(10,53, 'Email Address'); 

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        let primary_address_1 = "Primary Address Line 1		";
        let primary_address_2 = "Primary Address Line 2		";
        let primary_address_3 = "Primary Address Line 3		";
        pdf.text(10,58, primary_address_1); 
        pdf.text(10,63, primary_address_2); 
        pdf.text(10,68, primary_address_3); 

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(110,37, "Email: hello@evfy.sg");
        pdf.text(110,42, "Phone: +65 8932 3141");

        pdf.setFontSize(8);
        pdf.setFont("verdana","normal","400");
        pdf.text(140,53, "From");
        pdf.text(170,53, "To");

        pdf.setFont("verdana","bold","800");
        pdf.text(110,58, "Period:");
        pdf.text(110,63, "Invoice Number:");
        pdf.text(150,63, "	EVFY_year/mth/running no.	");
        pdf.text(110,68, "Date of Invoice:");

        pdf.autoTable({ 
          head: [ [{content: 'Delivery Invoice', colSpan:8,
                  styles: { halign: "center"}}],
                ['S/N', 'Date', 'Order Number', 'Job Type', 'Qty', 
                'Base Charge (SGD)', 'Surcharges (SGD)', 'Amount (SGD)']],
          body: [
            ['1', '', '', '', '', '' ,'', '$0.0'],
            ['2', '', '', '', '', '' ,'', '$0.0'],
            ['3', '', '', '', '', '' ,'', '$0.0'],
            ['4', '', '', '', '', '' ,'', '$0.0'],
            ['5', '', '', '', '', '' ,'', '$0.0'],
            [{content: 'This is an auto-generated invoice by Evfy Pte Ltd. For discrepencies, please contact us at 89323141', colSpan:6, 
            styles: { halign: "left", lineWidth: 0 }},
            {content: 'Discount (%)', colSpan:1, 
              styles: { halign: "right", lineWidth: 0 }
            }, '0 %'],
            [{content: 'Subtotal', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
            [{content: 'GST', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
            [{content: 'AMOUNT DUE TO US', colSpan:7, 
            styles: { halign: "right", lineWidth: 0 }
            }, '$0.0'],
          ],
          margin: { horizontal: 10, top: 75 },
          styles: { overflow: "linebreak" },
          bodyStyles: { valign: "top", halign: "center" },
          headerStyles: { fillColor: '#FFFFFF', textColor: 0, lineWidth: 0.5 },
          columnStyles: { email: { columnWidth: "wrap" } },
          theme: "grid",
            });

            pdf.autoTable({ 
            body: [
              [{content: 'The terms of payment shall be no later than 30 days from the date of invoice. For Cheque payment, please issue in favour of Evfy Pte Ltd For bank transfer payment: UOB 375-311-528-3', rowSpan:4,
              styles: { halign: "left", lineWidth: 0}}, {content: 'Official Use', colSpan:2,
              styles: { halign: "left"}}],
              [ {content: 'Status :', styles: { halign: "left"}}, 
                {content: 'Unpaid', rowSpan:3, styles: { halign: "left", fillColor: '#c3c3c3',}}],
                [{content: 'Mode:', styles: { halign: "left"}}], 
                [{content: 'Reference:', styles: { halign: "left"}}] 
            ],
            margin: { horizontal: 10, top: 75 },
            styles: { overflow: "linebreak" },
            bodyStyles: { valign: "top", halign: "center" },
            headerStyles: { fillColor: '#FFFFFF', textColor: 0, lineWidth: 0.5 },
            columnStyles: { 
              email: { columnWidth: "wrap" }, 
              0: {
                columnWidth: 120 },
              1: {
                columnWidth: 'auto' } },
            theme: "grid",
              });

        pdf.save(`Invoice.pdf`);
  }
  /* END EXPORT */

  render() {
    return <Container fluid>
      <Row className="p-4">
      
         {this.state.isLoadingStatus || this.state.isLoading? <Col xs={12} md={12} lg={12}>
         <div className="w-100 d-flex justify-content-center">
              <CircularProgress size={35}  />
            </div> </Col>:
        this.state.discount_list.length > 0 && this.state.discount_list.slice(0, 4).map((discount,index) =>(
          <Col xs={12} md={6} lg={3} className="mb-3">
            <Card classname="cd-shadow d-flex justify-content-center align-items-center m-auto overlay-warpper" style={{height: "490px", minHeight:'450px'}}>
            {(this.state.status_total + this.state.fail_total) >= Number(discount.eligible_order_count) && this.state.runIndex == discount.id? <div className='overlay-div d-flex justify-content-center align-items-center'>
                <div>
                  <div className="overflow-img text-center"><img src={stickCircle} alt="circle-checked" className="img-fluid discount-img"/></div>
                  <div className="text-center text-white fs-5 font-medium my-4">{discount.discount_value}{discount.discount_type == 'rate'? '%':'$'} discount secured!</div>
                </div>
              </div> : '' }
                <div className="p-4">
                  <div className="cus-discount">
                    <div style={{position:"relative", textAlign:"center"}}>
                      <img src={index == 0 ? discount0: index == 1 ? discount1 : index == 2? discount2: index == 3 ? discount3: ''} alt="5% discount" className="img-fluid discount-img"/>
                      <div style={{position:"absolute", top:"45%", left: "50%", transform:"translate(-50%, -50%)",fontWeight:"bold", fontSize:"25px",color:"white", lineHeight:1}}>{discount.discount_value}{discount.discount_type == 'rate'? '%':'$'} Off</div>
                    </div>
                  </div>
                  <div className="text-center fs-5 font-medium my-4">Your monthly bill</div>
                  <div>To qualify:
                    <ul>
                      <li>Order {discount.eligible_order_count } {discount.eligible_order_count && discount.eligible_order_count < 100 ? <>&nbsp;</> : '' } deliveries within the month</li>
                    </ul>
                  </div>
                  <div className="fs-3 font-medium progress-num-color-1 mt-4">{this.state.status_total + this.state.fail_total}</div>
                  <div className="progress progress-style-1">
                    <div className="progress-bar" role="progressbar" style={{width: (this.state.status_total/Number(discount.eligible_order_count)) * 100 > 100 ? 100 +'%' : ((this.state.status_total + this.state.fail_total)/Number(discount.eligible_order_count)) * 100 +'%'}} aria-valuenow={this.state.status_total} aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <div className="font-medium text-center my-4">Orders left to qualify: {(Number(discount.eligible_order_count) - (this.state.status_total + this.state.fail_total)) < 0 ? 0 : (Number(discount.eligible_order_count) - (this.state.status_total + this.state.fail_total)) }</div>
                </div>
            </Card> 
            
          </Col>
        )) }
        {/* <Col xs={12} md={6} lg={3} className="mb-3">
          <Card classname="cd-shadow d-flex justify-content-center align-items-center m-auto overlay-warpper" style={{height: "450px", minHeight:'450px'}}>
          {this.state.status_total > 100 ? <div className='overlay-div d-flex justify-content-center align-items-center'>
              <div>
                <div className="overflow-img text-center"><img src={stickCircle} alt="circle-checked" className="img-fluid discount-img"/></div>
                <div className="text-center text-white fs-5 font-medium my-4">5% discount secured!</div>
              </div>
            </div> : '' }
              <div className="p-4">
                <div className="cus-discount" >
                  <div style={{position:"relative", textAlign:"center"}}>
                    <img src={discount0} alt="5% discount" className="img-fluid discount-img"/>
                    <div style={{position:"absolute", top:"50%", left: "50%", transform:"translate(-50%, -50%)",fontWeight:"bold", fontSize:"28px",color:"white", lineHeight:1}}>100% Off</div>
                  </div>
                  
                </div>
                <div className="text-center fs-5 font-medium my-4">Your monthly bill</div>
                <div>To qualify:
                  <ul>
                    <li>Order 100 deliveries within the month</li>
                  </ul>
                </div>
                <div className="fs-3 font-medium progress-num-color-1 mt-4">{this.state.status_total}</div>
                <div className="progress progress-style-1">
                  <div className="progress-bar" role="progressbar" style={{width: this.state.status_total+'%'}} aria-valuenow={this.state.status_total} aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div className="font-medium text-center my-4">Orders left to qualify: {100 - this.state.status_total}</div>
              </div>
          </Card> 
        </Col> */}
      </Row>
      <Row className="px-4 pb-4">
      <Col xs={12} md={12} lg={12}>
      {this.state.isInvoiceLoading ? <div className="w-100 d-flex justify-content-center m-auto align-items-center text-center">
      <CircularProgress size={35}/>
    </div> :<Card className="p-3 cd-shadow d-flex " style={{minHeight:'100px', overflow: 'hidden'}}>
            <table>
              <tr>
                <td className="font-medium fs-6 py-2 text-start w-25">Invoices</td>
                <td className="font-medium fs-6 py-2 text-start w-25">Billed Date</td>
                <td className="font-medium fs-6 py-2 text-start w-25">Billed Amount</td>
                <td className="font-medium fs-6 py-2 text-start w-25">Status</td>
              </tr>
              {this.state.data.length > 0 && this.state.data.map( (dd) => (
                <tr className="border-bottom">
                <td className="py-3 text-start"><a href={dd.pdf_url} target="_blank" className="text-decoration-none text-start"><FontAwesomeIcon icon={faFilePdf} /> {dd.invoice_number.substr(0, 15) + "..."}</a></td>
                <td className="py-3 text-start">{moment(dd.due_date, "YYYY-MM-DD").add(1, 'M').format('DD/MM/YYYY')}</td>
                <td className="py-3 text-start">${ dd.amount? !isNaN(dd.amount)? parseFloat(dd.amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","): "0.00" : "0.00"}</td>
                <td className="py-3 text-start">{dd.is_paid ? <span className="font-medium" style={{color:"#0FBEA3"}}>Paid</span> : moment(moment(), "YYYY-MM-DD").unix() > moment(dd.due_date, "YYYY-MM-DD").add(1, 'M').unix()? <span className="font-medium" style={{color:"#FF0000"}}>Overdue</span> : <span className="font-medium" style={{color:"#FF881A"}}>Pending</span>}</td>

              </tr>
              ))}
            </table>
          </Card>}
        </Col>
      </Row>
    </Container>;
  }
}

export default Invoice;
